import { VipExpiredQueryOptions } from "@/apis/query/profile"
import { useCoinBalance } from "@/hooks/useCoinBalance"
import { useUserDetailStore } from "@/store/useUserDetailStore"
import { Energy } from "@/ui/icons/Energy"
import { useQuery } from "@tanstack/react-query"
import moment from "moment"
import { useMemo } from "react"

export default () => {
  const vip = useUserDetailStore(state => state.vip)
  const { coin } = useCoinBalance()
  const expiredData = useQuery({ ...VipExpiredQueryOptions, enabled: vip })
  const expiredDate = useMemo(() => {
    return moment((expiredData.data?.data || 0) * 1000).format(moment.localeData().longDateFormat('L')) + " " +
      moment((expiredData.data?.data || 0) * 1000).format(moment.localeData().longDateFormat('LT'))
  }, [expiredData.data])


  return (<>
    {vip ?
      <span>Expiration Date: {expiredDate}</span> :
      <span className="px-4 sm:px-10 py-1 flex items-center gap-1 border-1 border-theme-white/20 rounded-full text-[#FFF4CF]">
        <Energy /> <span className="leading-[1] mt-[2px] font-bold">{coin}</span>
      </span>}
  </>)
}